import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { format } from "date-fns";

interface RatingDisplayProps {
  rating: number;
  comment?: string | null;
  ratedAt?: string | null;
  showDate?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const RatingDisplay = ({
  rating,
  comment,
  ratedAt,
  showDate = true,
  size = 'md',
  className,
}: RatingDisplayProps) => {
  const starSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  return (
    <div className={cn("space-y-3", className)}>
      {/* Stars */}
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={cn(
              starSizes[size],
              star <= rating
                ? "fill-[#FFBF07] text-[#FFBF07]"
                : "text-[#DBE2EA]"
            )}
          />
        ))}
        <span className="ml-2 text-sm font-medium text-[#2D3748]">
          {rating}/5
        </span>
      </div>

      {/* Comment */}
      {comment && (
        <div className="bg-[#EBF4F8] rounded-lg p-4">
          <p className="text-sm text-[#2D3748] leading-relaxed">
            "{comment}"
          </p>
        </div>
      )}

      {/* Date */}
      {showDate && ratedAt && (
        <p className="text-xs text-[#87ADD4]">
          {format(new Date(ratedAt), 'dd/MM/yyyy HH:mm')}
        </p>
      )}
    </div>
  );
};
